// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
import Buefy from 'buefy'
import VueI18n from 'vue-i18n'

import '@fortawesome/fontawesome-free'
import '@fortawesome/fontawesome-free/css/all.css'

import App from './App'
import languageSet from './utils/LanguageSet'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(Buefy, {
  defaultIconPack: 'fas'
})

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages: languageSet,
  silentTranslationWarn: true
})

Vue.use(VueProgressBar, {
  color: '#83b692',
  failedColor: '#eb6666',
  thickness: '20px',
  location: 'top',
  autoFinish: false
  // height: '50px',
  // transition: {
  //   speed: '0.5s',
  //   opacity: '0.8',
  //   termination: 300
  // }
})

/* eslint-disable no-new */
new Vue({
  store,
  i18n,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js